import { useState } from "react";
import { ShoppingBag } from "lucide-react";
import { BuyDialog } from "./BuyDialog";
import { useInventory, productInStock } from "../hooks/useInventory";
import { useCatalog, formatPrice } from "../hooks/useCatalog";

export const ProductCard = ({ testId, v }) => {
  const [open, setOpen] = useState(false);
  const { stock, refresh } = useInventory();
  const soldOut = v.shop ? !productInStock(stock, v.shop.id) : false;
  const catalog = useCatalog();
  const livePrice = v.shop ? (catalog?.[v.shop.id]?.price ?? v.shop.price) : null;
  return (
    <article
      data-testid={`${testId}-card-${v.id}`}
      className="bg-white border border-ink/10 hover:border-oxblood/40 transition-colors duration-300 flex flex-col"
    >
      <div className="group relative overflow-hidden aspect-[4/5]">
        <img
          src={v.image}
          alt={v.name}
          loading="lazy"
          className="w-full h-full object-cover"
        />
        {soldOut && (
          <span
            data-testid={`${testId}-card-${v.id}-sold-out`}
            className="absolute top-3 right-3 z-10 bg-oxblood text-parchment font-mono text-[10px] uppercase tracking-[0.2em] px-2.5 py-1.5"
          >
            Sold out
          </span>
        )}
        {v.hoverImage && (
          <>
            <img
              src={v.hoverImage}
              alt={`${v.name} — alternate view`}
              loading="lazy"
              data-testid={`${testId}-card-${v.id}-hover-image`}
              className="absolute inset-0 w-full h-full object-cover opacity-0 group-hover:opacity-100 transition-opacity duration-500"
            />
            <span
              data-testid={`${testId}-card-${v.id}-hover-hint`}
              className="absolute bottom-3 left-3 bg-[#111111]/70 text-[#F9F8F5] font-mono text-[10px] uppercase tracking-[0.2em] px-2.5 py-1.5 group-hover:opacity-0 transition-opacity duration-300"
            >
              {v.hoverHint}
            </span>
          </>
        )}
      </div>
      <div className="p-6 flex flex-col flex-1">
        <div className="flex items-baseline justify-between gap-4">
          <h2 className="font-serif text-2xl text-ink">{v.name}</h2>
          {v.shop && (
            <p
              data-testid={`${testId}-card-${v.id}-price`}
              className="font-mono text-sm text-oxblood shrink-0"
            >
              ${formatPrice(livePrice)} CAD
            </p>
          )}
        </div>
        <p className="mt-3 mb-6 text-sm text-mutedink leading-relaxed">
          {v.description}
        </p>
        {v.shop && (
          <>
            <button
              type="button"
              data-testid={`${testId}-card-${v.id}-shop-btn`}
              onClick={() => setOpen(true)}
              className="mt-auto w-full inline-flex items-center justify-center gap-2 border border-ink text-ink py-3 font-mono text-[11px] uppercase tracking-[0.2em] hover:bg-ink hover:text-parchment transition-colors duration-300"
            >
              <ShoppingBag className="w-3.5 h-3.5" />
              {soldOut ? "Sold out — view" : "Shop"}
            </button>
            <BuyDialog
              product={{ ...v.shop, price: livePrice }}
              open={open}
              onOpenChange={setOpen}
              stock={stock}
              refreshStock={refresh}
            />
          </>
        )}
      </div>
    </article>
  );
};
